import React from 'react';
import styles from './OpsTasksPrintRow.module.scss';
import { OpsTask } from 'model/OpsTask';

interface OpsTasksPrintRowProps {
    task: OpsTask;
}

export const OpsTasksPrintRow: React.FC<OpsTasksPrintRowProps> = ({ task }) => {
    const roomName = task.rooms.length > 0 ? task.rooms.map(r => r.name).join(', ') : null;
    const staffName = task.staff.length > 0 ? task.staff.map(s => s.name).join(', ') : null;

    return (
        <tr className={styles.row}>
            <td className={styles.colDateTime}>
                <span className={styles.date}>{task.dueAt.format('MMM D, YYYY')}</span>
                <span className={styles.time}>{task.dueAt.format('h:mm a')}</span>
            </td>
            <td className={styles.colTask}>{task.description}</td>
            <td className={styles.colRoom}>{roomName ?? <span className={styles.unassigned}>Unassigned</span>}</td>
            <td className={styles.colStaff}>{staffName ?? <span className={styles.unassigned}>Unassigned</span>}</td>
            <td className={styles.colCheck}>
                <span className={styles.checkCircle} />
            </td>
        </tr>
    );
};

export default OpsTasksPrintRow;
